function flash_cwb(){
	var rawData = ajax_call(publicPath + '/napi/obs/weatherflash'),
		geojson = new geoJsonTemplate(),
		markerIcon = {
			iconUrl: '',
			iconAnchor:   [8, 16],
			iconSize:     [16, 16],
			popupAnchor:  [0, -8]
		}
	rawData.data.forEach(function(each){
		var field = each.description.split(/\n/ig)
		geojson.features.push({
			"type": "Feature",
			"geometry": {
				"type": "Point",
				"coordinates": [parseFloat(each.Point.coordinates[0]), parseFloat(each.Point.coordinates[1])]
			},
			"properties": {
				"type": field[0],
				"time": field[1],
				"coordinate": field[2]
			}
		})
	})
	var layer = L.geoJSON(geojson, {
		pointToLayer: function(feature, latlng) {
			if (feature.properties.type.match('對地')) {
				markerIcon["iconUrl"] = 'marker_icon/flash_ground.png';
			} else {
				markerIcon["iconUrl"] = 'marker_icon/flash_cloud.png';
			}
		 	return L.marker(latlng, {
				icon: new L.icon(markerIcon)
		  	}).bindPopup('<div id="other_area" class="w-200">資料連結中...</div>');
		}
	}).on('click', function(e){
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$('#other_area').html(
				'<h5 class="font-weight-bold">閃電圖層</h5>' +
				'<h6>' + this_marker.type + '</h6>' +
				'<h6>' + this_marker.time + '</h6>' +
				'<h6>' + this_marker.coordinate + '</h6>'
			)
		}, 1000)
	})
	return layer
}

function radar_cwb(){
	var rawData = ajax_call(publicPath + '/napi/obs/weatherradar'),
		obsTime = rawData.info.parameterSet.parameter.filter(el => {
			return el.parameterName === '時間'
		})[0].parameterValue.slice(0,16).replace("T", " "),
		geojson = new geoJsonTemplate()
	rawData.data.forEach(function(each){
		geojson.features.push({
			"type": "Feature",
			"geometry": {
		      	"type": "Polygon",
		      	"coordinates": [[[each.lon - 0.00625, each.lat - 0.00625], [each.lon + 0.00625, each.lat - 0.00625], [each.lon + 0.00625, each.lat + 0.00625], [each.lon - 0.00625, each.lat + 0.00625], [each.lon - 0.00625, each.lat - 0.00625]]]
			},
			"properties": {
				"value": each.value
			}
		})
	})
	var layer = L.geoJSON(geojson, {
		style: function (feature) {
			return {
				fillColor: radar_value_color_mapping(feature.properties.value),
				weight: 0,
				opacity: 0,
				fillOpacity: 0.5
			}
		},
		onEachFeature: function (feature, layer) {
			layer.bindPopup('<div id="other_area" class="w-200"></div>')
		}
	}).on('click', function(e){
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$('#other_area').html(
				'<h5 class="font-weight-bold">雷達強回波圖層</h5>' +
				'<h6>觀測時間：' + obsTime + '</h6>' +
				'<h6>雷達強回波值：' + this_marker.value + 'dBZ</h6>'
			)
		}, 1000)
	}).bringToBack()
	return layer
}

function rain_cwb(target = ''){
	var result = null, 
		data,
		rain_Icon = {
			iconUrl: '',
			iconAnchor:   [15, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		geojson_data = {
			type: "FeatureCollection",
			features: []
	  	}
	raw_data["雨量站"] ? ( (data = raw_data["雨量站"]) ) : ( (data = ajax_call(publicPath + "/napi/obs/rainobs")));
	data.forEach(function(element){
		// var time_lag = get_now_time_UTC() - time_sql_processing(element.TIME);
		// if (time_lag > 3600000 * 2) {
		// 	element["status"] = "異常"
		// } else {
		// 	if ((element.HOUR_24 >= 500)) {
		// 		element["status"] = '超大豪雨'
		// 	} else if ((element.HOUR_24 >= 350)) {
		// 		element["status"] = '大豪雨'
		// 	} else if(element.HOUR_24 >= 200 || element.HOUR_3 >= 100 ){
		// 		element["status"] = '豪雨'
		// 	} else if(element.HOUR_24 >= 80 || element.RAIN >= 40 ){
		// 		element["status"] = '大雨'
		// 	} else {
		// 		element["status"] = '正常'
		// 	}
		// }
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
		      	"type": "Point",
		      	"coordinates": [element.LON, element.LAT]
			},
			"properties": element
		})
	})
	var rain_layer = L.geoJSON(geojson_data,{
      	pointToLayer: function(feature, latlng) {
			switch (feature.properties.status) {
				case "超大豪雨":
				case "大豪雨":
				case "豪雨":
					rain_Icon["iconUrl"] = 'marker_icon/rain_r.png';
					break
				case "大雨":
					rain_Icon["iconUrl"] = 'marker_icon/rain_y.png';
					break
				case "正常":
					rain_Icon["iconUrl"] = 'marker_icon/rain_g.png';
					break
				case "異常":
					rain_Icon["iconUrl"] = 'marker_icon/rain_grey.png';
					break
				default:
					rain_Icon["iconUrl"] = 'marker_icon/rain_grey.png';
			}
        	return L.marker(latlng, {
          		icon: new L.icon(rain_Icon)
        	}).bindPopup('<div id="rain_area">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			switch (target) {
				case '超大豪雨':
					return feature.properties.status == '超大豪雨'
				case '大豪雨':
					return feature.properties.status == '大豪雨'
				case '豪雨':
					return feature.properties.status == '豪雨'
				case '大雨':
					return feature.properties.status == '大雨'
				case '正常':
					return feature.properties.status == '正常'
				case '離線':
					return feature.properties.status == '異常'
				default:
					return feature
			}
		}
    })
    rain_layer.on('click', onClick);
    result = [rain_layer, data];
    function onClick(e) {
		var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#rain_area').html(
				'<h5>' + this_marker.STNM + '</h5>' + 
				'<h6>時間：' + this_marker.TIME.slice(0,16) + '</h6>' + 
				'<h6>10分鐘雨量：' + rain_value_processing(this_marker.MIN_10) + 'mm</h6>' + 
				'<h6>時雨量：' + rain_value_processing(this_marker.RAIN) + 'mm</h6>' + 
				'<h6>近3小時雨量：' + rain_value_processing(this_marker.HOUR_3) + 'mm</h6>' + 
				'<h6>近6小時雨量：' + rain_value_processing(this_marker.HOUR_6) + 'mm</h6>' + 
				'<h6>近12小時雨量：' + rain_value_processing(this_marker.HOUR_12) + 'mm</h6>' + 
				'<h6>近24小時雨量：' + rain_value_processing(this_marker.HOUR_24) + 'mm</h6>' +
				'<div id="rain_div_chart" class="w-100 h-250"></div>'
			);
			var start_time = sql_query_start_time(this_marker.TIME),
				sql_query_sta = publicPath + "/napi/obs/rainobs?STID=" + this_marker.STID + "&StartTime=" + start_time + "&EndTime=" + this_marker.TIME.slice(0,16);
			ajax_call_async(sql_query_sta, function(data){
				var rain_dataset = {
						"hour": [], "hour_3": [], "hour_6": [], "hour_12": [], "hour_24": []
					},
					basedTime = time_sql_processing(data[0].TIME)
				data.forEach(function(element){
					var time = time_sql_processing(element.TIME);
					if (isInteger((basedTime - time) / 3600000)) {
						rain_dataset["hour"].push([time, rain_value_processing(element.RAIN)]);
					}
				})
				var plot_object = Highcharts.stockChart({
					chart: {
						type: 'column',
						zoomType: 'x',
						renderTo: 'rain_div_chart'
					},
					legend: {
						enabled: true
					},
			        rangeSelector: {
			        	enabled: false
					},
					navigator: {
						enabled: false
					},
					scrollbar: {
						enabled: false
					},
			        exporting:{
			        	enabled: false
					},
					plotOptions: {
						series: {
							dataGrouping: {
								enabled: false
							}
						}
					},
			        series: [{
			        	name: "時雨量",
			        	data: rain_dataset["hour"],
			        	tooltip: {valueDecimals: 2}
			        }],
			        yAxis: [{
			            title: {
			                text: "降雨量(mm)"
			            }
			        }]
				});
			})
		}, 1000);
	}
	return result;
}

function rain_value_processing(value){
	var result;
	switch(true){
		case(value >= 0):
			result = parseFloat(value);
			break;
		default:
			result = 0;
	}
	return result;
}

function rain_dynamic_viewer(){
	// --------------------------------- 降雨測站相關 ---------------------------------
	var rain_container = {}
	var rain_sum = {total: 0, red: 0, yellow: 0, normal: 0, grey: 0}
	var rain_data = raw_data["雨量站"], rain_tbody_data = [], rain_coor_object = {};
	rain_data.forEach(function(element){
		if (element.CITY == "新北市") {
			if (rain_container[element.TOWN] == undefined) {
				rain_container[element.TOWN] = {red: 0, yellow: 0, normal: 0, grey: 0};
			}
			if (element.status == "大雨") {
				rain_container[element.TOWN]["yellow"] += 1;
				rain_sum["yellow"] += 1;
			} else if (element.status == "豪雨") {
				rain_container[element.TOWN]["red"] += 1;
				rain_sum["red"] += 1;
			} else if (element.status == "正常") {
				rain_container[element.TOWN]["normal"] += 1;
				rain_sum["normal"] += 1;
			} else {
				rain_container[element.TOWN]["grey"] += 1;
				rain_sum["grey"] += 1;
			}
			rain_sum["total"] += 1;
			rain_tbody_data.push([element.TOWN, element.STNM, element.TIME.slice(0,16), rain_value_processing(element.MIN_10), rain_value_processing(element.RAIN), rain_value_processing(element.HOUR_24)]);
			rain_coor_object[element.STNM] = [element.LAT, element.LON];
		}
	});
	// --------------------------------- 降雨測站相關 ---------------------------------

	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("降雨動態")
		}, false) +
		'<h5 class="font-weight-bold"><i class="fas fa-tachometer-alt mt-3 mr-2"></i>檢視控制選擇</h5>'+
		'<div class="input-group mt-2">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">開始時間</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="qpe_player_start"></select>'+
		'</div>'+
		'<div class="input-group mt-2">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">結束時間</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="qpe_player_end"></select>'+
		'</div>'+
		'<div class="btn-group mt-2 btn-block">'+
			'<button type="button" class="btn btn-primary btn-sm" id="qpe_play"><i class="fas fa-play-circle mr-2"></i>播放</button>'+
			'<button type="button" class="btn btn-primary btn-sm" id="qpe_pause"><i class="fas fa-stop-circle mr-2"></i>停止</button>'+
			'<button type="button" class="btn btn-primary btn-sm" id="qpe_refresh"><i class="fas fa-redo mr-2"></i>更新</button>'+
			'<button type="button" class="btn btn-warning btn-sm d-none" id="qpe_clear"><i class="fas fa-times-circle mr-2"></i>清除</button>'+
	  		'<button type="button" id="qpe_name" class="btn btn-danger dropdown-toggle dropdown-toggle-split btn-sm d-none" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'+
    			'<span>時雨量</span>'+
	  		'</button>'+
			'<div class="dropdown-menu" id="qpe_list">'+
	    		'<a class="dropdown-item" href="#">時雨量</a>'+
		    	'<a class="dropdown-item" href="#">24小時雨量</a>'+
		    	'<a class="dropdown-item" href="#">72小時雨量</a>'+
			'</div>'+
		'</div>'+
		'<h5 class="mt-2" id="qpe_time_show"></h5>'+
		'<hr>' +
		'<h5 class="font-weight-bold mt-3"><i class="fas fa-chess-board mr-2"></i>雷達迴波圖</h5>'+
		'<img id="radar_view" src="" width="100%">' +
		'<h5 class="font-weight-bold mt-2"><i class="fas fa-cloud mr-2"></i>衛星雲圖</h5>'+
		'<img id="satelite_view" src="" width="100%">'+
		// --------------------------------- 降雨測站相關 ---------------------------------
		slider_card_component_create({
			"cardhead": "降雨示警統計資訊",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>豪雨' + rain_sum["red"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						  '<div class="progress-bar bg-alert-red rain-red-bar" role="progressbar" aria-valuenow="' + (rain_sum["red"]/rain_sum["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>大雨' + rain_sum["yellow"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-yellow rain-yellow-bar" role="progressbar" aria-valuenow="' + (rain_sum["yellow"]/rain_sum["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>未達' + rain_sum["normal"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-green rain-normal-bar" role="progressbar" aria-valuenow="' + (rain_sum["normal"]/rain_sum["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>異常' + rain_sum["grey"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-grey rain-grey-bar" role="progressbar" aria-valuenow="' + (rain_sum["grey"]/rain_sum["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="rain_sta" class="col-12 h-280"></div>'+
				'<div class="col-12 mb-3" id="rain_table">'+
					'<table class="table table-sm text-center" width="100%">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th rowspan="2">行政區</th>' +
								'<th rowspan="2">站名</th>' +
								'<th rowspan="2">時間</th>' +
								'<th class="text-center" colspan="3">觀測雨量</th>' +
							'</tr>' +
							'<tr>' +
								'<th>10分鐘</th>' +
								'<th>1小時</th>' +
								'<th>24小時</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody class="p-cursor"></tbody>' +
					'</table>'+
				'</div>'
		})
		// --------------------------------- 降雨測站相關 ---------------------------------
	);

	// --------------------------------- 降雨測站相關 ---------------------------------
	for (var level in rain_sum) {
		$(".rain-" + level + "-bar").css("width", (rain_sum[level] / rain_sum["total"])*100 + "%")	
	}

	$('#rain_table table').DataTable({
        "data": rain_tbody_data,
        "deferRender": true,
        "order": [[ 3, "desc" ]],
        "searching": true
    });

    $("#rain_table tbody").on("click", "tr", function(){
        var coor_array = rain_coor_object[$(this).find("td").eq(1).html()];
        map.setView(coor_array, 18);
    });

	stacked_percent_chart({
		div: "rain_sta",
		data: rain_container,
		key_name: ["red", "yellow", "normal", "grey"],
		label: ["豪雨", "大雨", "未達", "異常"],
		color: ['#e85a71', '#FFBC42', '#3ac569', '#ced4da']
	});
	// --------------------------------- 降雨測站相關 ---------------------------------

	$("#qpe_refresh").click(function(){
		qpe_initial_panel();
	});
	
	qpe_initial_panel();
	function qpe_initial_panel(){
		var date_list_array = {name: [], value: []};
		var html_string = "";
		for (var i = 0; i <= 47 ; i++) {
			var day_prototype = new Date();
			day_prototype.setHours(day_prototype.getHours() - i);
			var year = day_prototype.getFullYear();
			var month = day_prototype.getMonth()+1;
			var date = day_prototype.getDate();
			var hour = day_prototype.getHours();
			var this_value = "" + year + time_string_processing(month) + time_string_processing(date) + "." + time_string_processing(hour) + "00";
			var this_name = year + "/" + time_string_processing(month) + "/" + time_string_processing(date) + " " + time_string_processing(hour) + "：00";
			date_list_array["name"].push(this_name);
			date_list_array["value"].push(this_value);
			html_string += '<option value="' + this_value +'">' + this_name + '</option>';
		}
		date_list_array["name"].reverse();
		date_list_array["value"].reverse();
		$("#qpe_player_start").html(html_string);
		$("#qpe_player_end").html(html_string);
		cwb_pic(date_list_array["name"][47], date_list_array["name"][46]);
		function cwb_pic(input, input_last){
			var pic_year = [input.slice(0,4), input_last.slice(0,4)];
			var pic_month = [input.slice(5,7), input_last.slice(5,7)];
			var pic_date = [input.slice(8,10), input_last.slice(8,10)];
			var pic_hour = [input.slice(11,13), input_last.slice(11,13)];
			var satelite_view_url = "https://www.cwa.gov.tw/Data/satellite/TWI_IR1_CR_800/TWI_IR1_CR_800-" + pic_year[0] + "-" + pic_month[0] + "-" + pic_date[0] + "-" + pic_hour[0] + "-00.jpg";
			var radar_view_url = "https://www.cwa.gov.tw/Data/radar/CV1_3600_" + pic_year[0] + pic_month[0] + pic_date[0] + pic_hour[0] + "00.png";
			$("#satelite_view").attr("src", satelite_view_url).on("error", function(){
				satelite_view_url = "https://www.cwa.gov.tw/Data/satellite/TWI_IR1_CR_800/TWI_IR1_CR_800-" + pic_year[1] + "-" + pic_month[1] + "-" + pic_date[1] + "-" + pic_hour[1] + "-00.jpg";
				$("#satelite_view").attr("src", satelite_view_url)
			});
			$("#radar_view").attr("src", radar_view_url).on("error", function(){
				radar_view_url = "https://www.cwa.gov.tw/Data/radar/CV1_3600_" + pic_year[1] + pic_month[1] + pic_date[1] + pic_hour[1] + "00.png";
				$("#radar_view").attr("src", radar_view_url)
			});
		}

		function rain_hour_select_controller(input, input_last){
			if (overlay_dataset["QPE"] != undefined) {
				map.removeLayer(overlay_dataset["QPE"]);
			}
			var qpe_type = (function(){
				var string = $("#qpe_name span").html();
				var result;
				switch(string){
					case "時雨量":
						result = "1hr";
						break;
					case "24小時雨量":
						result = "24hr";
						break;
					case "72小時雨量":
						result = "72hr";
						break;
				}
				return result;
			})();
			$("#qpe_time_show").html("目前檢視的時間為：<br>" + date_list_array["name"][input]);
			cwb_pic(date_list_array["name"][input], date_list_array["name"][input_last]);
			var url = publicPath + "/napi/obs/rainqpe?time=" + date_list_array["value"][input] + "&type=" + qpe_type;
			var data = ajax_call(url)["data"];
			var geo_json = {type: "FeatureCollection", features: []};
			var array = [];
			data = data.split('\n');
			data.forEach(function(element){
				var each_grid = element.split(' ');
				var push_array = [each_grid[3], each_grid[4], each_grid[5]];
				if (each_grid[5] == undefined) {
					push_array = [each_grid[2], each_grid[3], each_grid[4]];
				}
				array.push(push_array)
			});
			array.forEach(function(element){
				var coor_x = parseFloat(element[2]);
				var coor_y = parseFloat(element[1]);
				if (coor_y > 24.538868 && coor_x > 120.894939) {
					geo_json.features.push({
						"type": "Feature",
						"geometry": {
					      	"type": "Polygon",
					      	"coordinates": [[[(coor_x-0.00625), (coor_y+0.00625)],[(coor_x+0.00625), (coor_y+0.00625)],[(coor_x+0.00625), (coor_y-0.00625)],[(coor_x-0.00625), (coor_y-0.00625)],[(coor_x-0.00625), (coor_y+0.00625)]]]
						},
						"properties": {
							"value": parseFloat(element[0])
						}
					})
				}
			});
			overlay_dataset["QPE"] = L.geoJSON(geo_json, {
				style: rainGridStyle,
				onEachFeature: function (feature, layer) {
					layer.bindPopup('<div id="other_area" class="w-200"></div>')
				}
			}).addTo(map);
			overlay_dataset["QPE"].on('click', onClick);
			function onClick(e) {
				var this_marker = e.layer.feature.properties;
				setTimeout(function(){
					$('#other_area').html(
						'<h5>雷達雨量觀測(QPE)</h5>' + 
						'<h6>降雨量：' + this_marker["value"] + 'mm</h6>'
					)			
				}, 1000);			
			}
		}

		$("#qpe_play").click(function(){
			if (overlay_dataset["日累積降雨"] != undefined) {
				backgroud_layer_control("日累積降雨", "close");
			};
			if ($("#legend_tag_降雨網格").length == 0) {
				$("#legend_div_container").append('<div class="mb-1 legend_text" id="legend_tag_降雨網格"> 降雨網格<br> <img src="Legend/qpe_legend.png" width="100%"> </div>');
			};
			map.setView({lon: 121.280, lat: 25.038169}, 10);
			var start = $("#qpe_player_start :selected").val();
			var end = $("#qpe_player_end :selected").val();
			var start_index, end_index;
			date_list_array["value"].forEach(function(element, index){
				if (start == element) {
					start_index = index;
				}
				if (end == element) {
					end_index = index;
				}
			})
			var step = 0, myVar = {};
			for (var j = start_index; j <= end_index; j++) {
				(function(index) {
					myVar[j] = setTimeout(function(){
						rain_hour_select_controller(index, (index-1));
					}, 3000 * step);
					step = step + 1;
				})(j);
			}
			$("#qpe_pause").click(function(){
				for(var j = start_index; j <= end_index; j++) {
					clearTimeout(myVar[j]);
				}
			});
		})

	}

	// qpe type selector
	$("#qpe_list .dropdown-item").click(function(){
		var string = $(this).html();
		$("#qpe_name span").html(string);
	});

	// qpe layer remover
	$("#qpe_clear").click(function(){
		if (overlay_dataset["QPE"] != undefined) {
			map.removeLayer(overlay_dataset["QPE"]);
		}
	});
}

function rainGridStyle(feature){
	var color; var fillOpacity = 0.4;
	switch(true) {
		case (feature.properties.value <= 0):
			color = "#fff";
			fillOpacity = 0;
			break;
		case (feature.properties.value > 0 && feature.properties.value <= 1):
			color = "#c1c1c1";
			break;
		case (feature.properties.value > 1 && feature.properties.value <= 2):
			color = "#98ffff"
			break;
		case (feature.properties.value > 2 && feature.properties.value <= 6):
			color = "#00ceff"
			break;
		case (feature.properties.value > 6 && feature.properties.value <= 10):
			color = "#0198ff"
			break;
		case (feature.properties.value > 10 && feature.properties.value <= 15):
			color = "#0562ff"
			break;
		case (feature.properties.value > 15 && feature.properties.value <= 20):
			color = "#319904"
			break;
		case (feature.properties.value > 20 && feature.properties.value <= 30):
			color = "#36ff00"
			break;
		case (feature.properties.value > 30 && feature.properties.value <= 40):
			color = "#faff00"
			break;
		case (feature.properties.value > 40 && feature.properties.value <= 50):
			color = "#ffcc01"
			break;
		case (feature.properties.value > 50 && feature.properties.value <= 70):
			color = "#ff9703"
			break;
		case (feature.properties.value > 70 && feature.properties.value <= 90):
			color = "#f00800"
			break;
		case (feature.properties.value > 90 && feature.properties.value <= 110):
			color = "#cc0003"
			break;
		case (feature.properties.value > 110 && feature.properties.value <= 130):
			color = "#a00000"
			break;
	}
	return {
		fillColor: color,
		weight: 0,
		opacity: 0,
		fillOpacity: fillOpacity
	};
}

function wind_cwb(){
	var result = null;
	var Icon_setting = {
	    iconUrl: 'marker_icon/wind.png',
	    iconAnchor:   [15, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	};
	var geojson_data = new geoJsonTemplate()
	var scriptUrl = publicPath + '/napi/obs/windobs';
	var wind_non_auto = ajax_call(scriptUrl);
	var all_wind_sta = [wind_non_auto];
	for (var index in all_wind_sta) {
		var element_type = "CWB_A0003-001";
		all_wind_sta[index].forEach(function(element){
			geojson_data.features.push({
				"type": "Feature",
				"geometry": {
			      	"type": "Point",
			      	"coordinates": [parseFloat(element.lon_wgs84), parseFloat(element.lat_wgs84)]
				},
				"properties": {
					"STID": element.station_id,
					"STNM": element.location_name,
					"TIME": element.time.slice(0,16),
					"WDIR": parseFloat(element.wind_direction),
					"WDSD": parseFloat(element.wind_speed),
					"TEMP": parseFloat(element.temperature),
					"PRES": parseFloat(element.pressure),
					"TYPE": element_type
				}
			})
		})
	}
	var wind_layer = L.geoJSON(geojson_data, {
	  	pointToLayer: function(feature, latlng) {
	    	return L.marker(latlng, {
	      		icon: new L.icon(Icon_setting),
	    	}).bindPopup('<div id="wind_area" class="w-200">資料連結中...</div>');
	  	}
	})
	wind_layer.on('click', onClick)
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#wind_area').html(
				'<h5>' + this_marker.STNM + '</h5>' + 
				'<h6>時間：' + this_marker.TIME + '</h6>' + 
				'<h6>風速：' + this_marker.WDSD + 'm/s</h6>' + 
				'<h6>風向：' + this_marker.WDIR + '°</h6>' + 
				'<h6>溫度：' + this_marker.TEMP + '°C</h6>' + 
				'<h6>大氣壓力：' + this_marker.PRES + 'hPa</h6>' 
			)
		}, 1000)
    }
	result = wind_layer
	return result
}

function typhoon_info(){
    var result = null;
    // potential path
    var ty_path_data = L.geoJson(null, {
        style: function(feature) {
            var id_geotype = [feature.properties.styleUrl, feature.geometry.type];
            var plot_color;
            if (id_geotype[0] == "#past-track" && id_geotype[1] == "LineString") {
            	plot_color = {color: "#aa9999"};
            } else if(id_geotype[0] == "#current" && id_geotype[1] == "Polygon"){
            	plot_color = {color: "#ffdddd", fill: false};
            } else if(id_geotype[0] == "#fcst" && id_geotype[1] == "LineString"){
            	plot_color = {color: "#ffffff"};
            } else if(id_geotype[0] == "#pta" && id_geotype[1] == "Polygon"){
            	plot_color = {color: "#ff0000", fillColor: "#ffff55", fillOpacity: 0.13};
            } else{
            }
    		return plot_color;
        },
        pointToLayer: function(feature, latlng) {
            var icon_object = {
    		    iconUrl: '',
    		    iconAnchor:   [8, 8],
    		    iconSize:     [16, 16],
    		    popupAnchor:  [0, -10]
    		}
        	if(feature.geometry.type == "Point" && feature.properties.styleUrl == "#current"){
        		icon_object["iconUrl"] = "marker_icon/typhoon.png";
        	}
        	if(feature.geometry.type == "Point" && feature.properties.styleUrl == "#fcst"){
        		icon_object["iconUrl"] = "marker_icon/typhoon-fcst.png";
        	}
            var html_string = '<h6>' + feature.properties["name"] + '</h6>' + '<h6>' + feature.properties["description"] + '</h6>';
            return L.marker(latlng, {
                icon: new L.Icon(icon_object)
            }).bindPopup('<div id="other_area">' + html_string + '</div>');
      	}
    });
    var ty_path_layer = omnivore.kml(publicPath + '/napi/obs/typhoonpath?jwt=' + localStorage.getItem('jwt_token'), null, ty_path_data);
    // position label
    var ty_position_label = L.geoJson(null, {
        filter: function(feature, layer){
            var ans = (feature.geometry.type == "Point");
            return ans;
        },
        pointToLayer: function(feature, latlng) {
            if(feature.geometry.type == "Point"){
                var coor = latlng;
                return L.marker({lat: (coor.lat-0.04), lng: coor.lng}, {
                    icon: createLabelIcon("leaflet-textLabelclass", feature.properties.name)
                });
            }
        }
    });
    var ty_position_label_layer = omnivore.kml(publicPath + '/napi/obs/typhoonpath?jwt=' + localStorage.getItem('jwt_token'), null, ty_position_label);
    // potential area
    var ty_fcst_data = L.geoJson(null, {
        style: function(feature) {
            var id_geotype = feature.properties.name;
            var plot_color;
            switch(id_geotype){
            	case "100%":
            		plot_color = {fillColor: "#ff0000", fillOpacity: 0.53, opacity: 0};
            		break;
            	case "80%":
            		plot_color = {fillColor: "#ff9d00", fillOpacity: 0.53, opacity: 0};
            		break;
            	case "60%":
            		plot_color = {fillColor: "#ffd500", fillOpacity: 0.47, opacity: 0};
            		break;
            	case "40%":
            		plot_color = {fillColor: "#33cc33", fillOpacity: 0.40, opacity: 0};
            		break;
            	case "20%":
            		plot_color = {fillColor: "#009933", fillOpacity: 0.40, opacity: 0};
            		break;
            }
    		return plot_color;
        }
    });
    var ty_fcst_layer = omnivore.kml(publicPath + '/napi/obs/typhoonarea?jwt=' + localStorage.getItem('jwt_token'), null, ty_fcst_data);
    var ty_all_layer = L.layerGroup([ty_path_layer, ty_position_label_layer, ty_fcst_layer]);
    result = ty_all_layer;
    return result;
}

function flood_potential_wrap(name){
	var result = null;
	var scriptUrl = 'geojson/wrap/' + name +'.json';
	function style(feature) {
		var color; var fillOpacity = 0.6;
		switch(feature.properties.CLASS) {
		    case 1:
		        color = "#cff0da";
		        fillOpacity = 0;
		        break;
		    case 2:
		        color = "#fcb906"
		        break;
		    case 3:
		        color = "#ff620a"
		        break;
		    case 4:
		        color = "#fc0000"
		        break;
		    case 5:
		        color = "#840000"
		        break;
		}
    	return {
	        fillColor: color,
	        weight: 0,
	        opacity: 1,
	        // color: 'black',
	        // dashArray: '3',
	        fillOpacity: fillOpacity
	    };
	}
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'json',
		async: false,
		success: function(data) {
			var flood_layer = L.geoJSON(data,{
				style: style,
				onEachFeature: function (feature, layer) {
					var text;
					switch(feature.properties.CLASS) {
					    case 1:
					        text = "(0~0.3)公尺"
					        break;
					    case 2:
					        text = "(0.3~1)公尺"
					        break;
					    case 3:
					        text = "(1~2)公尺"
					        break;
					    case 4:
					        text = "(2~3)公尺"
					        break;
					    case 5:
					        text = "(>3)公尺"
					        break;
			    	}
				    layer.bindPopup('<div class="w-250"><h6>淹水潛勢' + name + '</h6><h6>淹水深度等級: '+ text +'</h6></div>');
				}
			});
		    result = flood_layer;
		} 
	});
	return result;
}

function flood_history_wrap(){
	var result = null;
	var scriptUrl = 'geojson/wrap/history_flood.json';
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'json',
		async: false,
		success: function(data) {
			var flood_history_layer = L.geoJSON(data,{
				style: {
			        fillColor: "#45d9fd",
			        weight: 2,
			        opacity: 1,
			        color: 'white',
			        dashArray: '3',
			        fillOpacity: 0.6
			    },
				onEachFeature: function (feature, layer) {
				    layer.bindPopup('<div class="w-250"><h5>歷史淹水範圍</h5><h6>事件名稱：'+ feature.properties.FolderPath +'</h6><h6>淹水面積：' + feature.properties.Shape_Area.toFixed(2) + 'ha</h6></div>');
				}
			})
		    result = flood_history_layer;
		} 
	});
	return result;
}

function history_flood_village() {
	var result = null;
	var scriptUrl = 'geojson/wrap/history_flood_village.json';
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'json',
		async: false,
		success: function(data) {
			var history_flood_village_layer = L.geoJSON(data,{
				style: {
			        weight: 2,
			        opacity: 1,
			        color: '#ef5285',
			        fillOpacity: 0
			    },
				onEachFeature: function (feature, layer) {
				    layer.bindPopup('<div class="w-250"><h5>淹水易致災村里</h5><h6>行政區' + feature.properties.TOWNNAME + '</h6><h6>村里：'+ feature.properties.VILLNAME +'</h6><h6>事件名稱：' + feature.properties.FolderPath + '</h6><h6>淹水面積：' + feature.properties.Shape_Area.toFixed(3) + 'ha</h6></div>');
				}
			})
		    result = history_flood_village_layer;
		} 
	});
	return result;
}

function flood_history_event(){
	var result = null;
	var scriptUrl = publicPath + '/napi/emis/ntc_all_flood_cases?start=2012&end=2020';
	var data = ajax_call(scriptUrl);
	var event_array = { max:4, data:[]};
	for (var i = 0; i < data.length; i++) {
		event_array.data.push({lat: data[i]["WGS_Y"], lng: data[i]["WGS_X"], count: 1});
	}
	var cfg = {
		// radius should be small ONLY if scaleRadius is true (or small radius is intended)
		// if scaleRadius is false it will be the constant radius used in pixels
		"radius": 0.003,
		"maxOpacity": .8, 
		// scales the radius based on map zoom
		"scaleRadius": true, 
		// if set to false the heatmap uses the global maximum for colorization
		// if activated: uses the data maximum within the current map boundaries 
		//   (there will always be a red spot with useLocalExtremas true)
		"useLocalExtrema": false,
		latField: 'lat',
		lngField: 'lng',
		valueField: 'count'
	};
	var heatmapLayer = new HeatmapOverlay(cfg);
	heatmapLayer.setData(event_array);
	result = heatmapLayer;
	return result;
}

function flood_depth_class(depth){
	var result, depth = parseFloat(depth);
	switch(true) {
	    case (depth >= 0.3 && depth <= 1):
	        result = "(0.3~1)公尺";
	        break;
	    case (depth > 1 && depth <= 2):
	        result = "(1~2)公尺";
	        break;
	    case (depth > 2 && depth <= 3):
	        result = "(2~3)公尺";
	        break;
	    case (depth > 3):
	        result = "(>3)公尺";
	        break;
	};
	return result;
}

function findLatLang(latlng, geocoder, delay) {
    return new Promise(function(resolve, reject) {
    	setTimeout(function(){
	        geocoder.geocode({'location': latlng}, function(results, status) {
	            if (status === 'OK') {
	                resolve(results[0].formatted_address);
	            } else {
	                // reject(new Error('Couldnt\'t find the location ' + address));
	            }
	    	})
	   	}, delay * 1000);
    })
}

function getPoints(geocoder, input_data) {
    var addressData = [];
    for(var i = 0; i < input_data["latlng"].length; i++){
        addressData.push(findLatLang(input_data["latlng"][i], geocoder, i))
    }
    return addressData;
}

function stage_wrs(target = ''){
	var result = null, 
		data;
	var Icon_setting = {
	    iconUrl: 'marker_icon/stage_0.png',
	    iconAnchor:   [15, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	};
	var stage_coors = {
		"DVR800": [121.317598,25.106639],
		"DVR803": [121.438268,25.087085],
		"DVR804": [121.456247,24.981088],
		"DVR805": [121.368822,24.931731],
		"DVR806": [121.504835,24.958267]
	}
	var geojson_data = new geoJsonTemplate()
	raw_data["水利局水位"] ? ( (data = raw_data["水利局水位"]) ) : ( (data = ajax_call(publicPath + "/napi/obs/wrswaterlevel")));
	for (var stage_coor in stage_coors) {
		data.forEach(function(element){
			if (stage_coor == element.sensor_name) {
				geojson_data.features.push({
					"type": "Feature",
    				"geometry": {
				      	"type": "Point",
				      	"coordinates": stage_coors[stage_coor]
    				},
    				"properties": {
      					"STID": element.sensor_name,
      					"STNM": element.stn_name,
      					"TIME": element.time,
      					"WaterLevel": element.waterl_evel,
      					"AlertLevel": element.alert_level_1
    				}
				})
			}
		})
	}
	var stage_layer = L.geoJSON(geojson_data, {
      	pointToLayer: function(feature, latlng) {
      		Icon_setting["iconUrl"] = "marker_icon/stage_0.png";
      		if (feature.properties.WaterLevel >= feature.properties.AlertLevel) {
      			Icon_setting["iconUrl"] = "marker_icon/stage_3.png";
      		}
      		var stage_Icon = new L.icon(Icon_setting)
        	return L.marker(latlng, {
          		icon: stage_Icon
        	}).bindPopup('<div id="stage_area">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			let offline = get_now_time_UTC() - time_sql_processing(feature.properties.TIME) > 3600000 * 2
			switch (target) {
				case '一級':
					return feature.properties.WaterLevel >= feature.properties.AlertLevel && !offline
				case '未達警戒':
					return feature.properties.WaterLevel < feature.properties.AlertLevel && !offline
				case '離線':
					return offline
				default:
					return feature
			}
		}
    })
    stage_layer.on('click', onClick);
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#stage_area').html(
				'<h5>' + this_marker.STNM + '</h5>' + 
				'<h6>時間：' + this_marker.TIME.slice(0,16) + '</h6>' + 
				'<h6>水位：' + parseFloat(this_marker.WaterLevel).toFixed(2) + 'm</h6>' + 
				'<h6>一級警戒水位：' + parseFloat(this_marker.AlertLevel).toFixed(2) + 'm</h6>' + 
				'<div id="stage_div_chart" class="w-100 h-250"></div>'
			)
			var start_time = sql_query_start_time(this_marker.TIME);
			var sql_query_sta = publicPath + "/napi/obs/wrswaterlevel?STID=" + this_marker.STID + "&StartTime=" + start_time + "&EndTime=" + this_marker.TIME.slice(0,16);
			ajax_call_async(sql_query_sta, function(data){
				var dataset = [];
				data.forEach(function(element){
					var time = time_sql_processing(element.time);
					dataset.push([time, parseFloat(element.waterl_evel)]);
				})
				Highcharts.stockChart({
					chart: {
						type: 'spline',
						zoomType: 'x',
						renderTo: 'stage_div_chart'
					},
					legend: {
						enabled: true
					},
			        rangeSelector: {
			        	enabled: false
			        },
					navigator: {
						enabled: false
					},
					scrollbar: {
						enabled: false
					},
			        exporting:{
			        	enabled: false
			        },
			        series: [{
			        	name: "水位",
			        	data: dataset,
			        	tooltip: { valueDecimals: 2}
			        }],
			        yAxis: [{
			        	max: this_marker.AlertLevel,
			            title: {
			                text: "水位(m)"
			            },
			            plotLines: [{
			                value: this_marker.AlertLevel,
			                color: 'red',
			                dashStyle: 'shortdash',
			                width: 2,
			                label: {
			                    text: '一級警戒水位'
			                }
			            }]
			        }]
				});
			})		
		}, 1000);
    }
    result = [stage_layer, data];
	return result;
}

function stage_wra(target = ''){
	var result = null;
	var Icon_setting = {
			iconUrl: 'marker_icon/stage_0.png',
			iconAnchor:   [15, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		data
	var geojson_data = {
	  	type: "FeatureCollection",
	  	features: []
	};
	raw_data["水利署水位"] ? ( (data = raw_data["水利署水位"]) ) : ( (data = ajax_call(publicPath + "/napi/obs/wrawaterlevel")));
	data.forEach(function(element){
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
				"type": "Point",
				"coordinates": [element.lon_wgs84, element.lat_wgs84]
			},
			"properties": {
				"BasinIdentifier": element.station_identifier,
				"ObservatoryName": element.observatory_name,
				"LocationAddress": element.location_address,
				"RiverName": element.river_name,
				"AlertLevel1": element.alert_level_1,
				"AlertLevel2": element.alert_level_2,
				"AlertLevel3": element.alert_level_3,
				"WaterLevel": element.water_level,
				"RecordTime": element.time,
			}
		})
	})
	var stage_layer = L.geoJSON(geojson_data, {
      	pointToLayer: function(feature, latlng) {
      		Icon_setting["iconUrl"] = "marker_icon/stage_0.png";
      		if (feature.properties.WaterLevel >= feature.properties.AlertLevel3 && feature.properties.WaterLevel < feature.properties.AlertLevel2 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel3 != null) {
      			Icon_setting["iconUrl"] = "marker_icon/stage_1.png";
      		} else if(feature.properties.WaterLevel >= feature.properties.AlertLevel2 && feature.properties.WaterLevel < feature.properties.AlertLevel1 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel1 != null){
      			Icon_setting["iconUrl"] = "marker_icon/stage_2.png";
      		} else if(feature.properties.WaterLevel >= feature.properties.AlertLevel1 && feature.properties.AlertLevel1 != null){
      			Icon_setting["iconUrl"] = "marker_icon/stage_3.png";
      		}
      		var time_lag = get_now_time_UTC() - time_sql_processing(feature.properties.RecordTime);
      		if (time_lag > 3600000 * 2) {
      			Icon_setting["iconUrl"] = "marker_icon/stage_999.png";
      		};
      		var stage_Icon = new L.icon(Icon_setting)
        	return L.marker(latlng, {
          		icon: stage_Icon
        	}).bindPopup('<div id="stage_area">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			var time_lag = get_now_time_UTC() - time_sql_processing(feature.properties.RecordTime);
			var in_alert =
				(feature.properties.WaterLevel >= feature.properties.AlertLevel3 && feature.properties.WaterLevel < feature.properties.AlertLevel2 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel3 != null) ||
				(feature.properties.WaterLevel >= feature.properties.AlertLevel2 && feature.properties.WaterLevel < feature.properties.AlertLevel1 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel1 != null) ||
				(feature.properties.WaterLevel >= feature.properties.AlertLevel1 && feature.properties.AlertLevel1 != null);
			switch (target) {
				case '一級':
					return feature.properties.WaterLevel >= feature.properties.AlertLevel3 && feature.properties.WaterLevel < feature.properties.AlertLevel2 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel3 != null
				case '二級':
					return feature.properties.WaterLevel >= feature.properties.AlertLevel2 && feature.properties.WaterLevel < feature.properties.AlertLevel1 && feature.properties.AlertLevel2 != null && feature.properties.AlertLevel1 != null
				case '三級':
					return feature.properties.WaterLevel >= feature.properties.AlertLevel1 && feature.properties.AlertLevel1 != null
				case '未達警戒':
					return time_lag <= 3600000 * 2 && !in_alert
				case '離線':
					return time_lag > 3600000 * 2
				default:
					return feature
			}
		}
    })
    stage_layer.on('click', onClick);
    function onClick(e) {
    	var this_marker = e.layer.feature.properties,
			this_layer = e.layer,
			alert_label = [{"label_set":"AlertLevel1", "color_set": 'red', "text_set": "一級警戒水位"}, {"label_set":"AlertLevel2", "color_set": 'purple', "text_set": "二級警戒水位"}, {"label_set":"AlertLevel3", "color_set": 'orange', "text_set": "三級警戒水位"}];
		setTimeout(function(){
			$('#stage_area').html(
				'<h5>' + this_marker.BasinIdentifier + this_marker.ObservatoryName + '</h5>' + 
				'<h6>時間：' + this_marker.RecordTime.slice(0,16) + '</h6>' + 
				'<h6>水位：' + null_Converter_v2(parseFloat(this_marker.WaterLevel).toFixed(2)) + 'm</h6>' + 
				'<h6>一級警戒水位(m)：' + null_Converter(this_marker.AlertLevel1) + '</h6>' + 
				'<h6>二級警戒水位(m)：' + null_Converter(this_marker.AlertLevel2) + '</h6>' + 
				'<h6>三級警戒水位(m)：' + null_Converter(this_marker.AlertLevel3) + '</h6>' + 
				'<button type="button" class="btn btn-danger btn-sm mb-2" id="region_cctv_trig"><i class="far fa-images mr-2"></i>查看鄰近CCTV影像</button>' +
				'<div id="stage_div_chart" class="w-100 h-250"></div>'
			);
			var max_set = this_marker.AlertLevel1, start_time = sql_query_start_time(this_marker.RecordTime), sql_query_sta = publicPath + "/napi/obs/wrawaterlevel?StationIdentifier=" + this_marker.BasinIdentifier + "&StartTime=" + start_time + "&EndTime=" + this_marker.RecordTime;
			ajax_call_async(sql_query_sta, function(data){
				var stage_CL_setting = [];
				alert_label.forEach(function(element){
					stage_CL_setting.push({
						value: this_marker[element.label_set],
		                color: element.color_set,
		                dashStyle: 'shortdash',
		                width: 2,
		                label: {
		                    text: element.text_set
		                }
					})
				})
				var dataset = [];
				data.forEach(function(element){
					var time = time_sql_processing(element.time);
					dataset.push([time, parseFloat(element.water_level)]);
				})
				Highcharts.stockChart({
					chart: {
						type: 'spline',
						zoomType: 'x',
						renderTo: 'stage_div_chart'
					},
					legend: {
						enabled: true
					},
			        rangeSelector: {
			        	enabled: false
			        },
					navigator: {
						enabled: false
					},
					scrollbar: {
						enabled: false
					},
			        exporting:{
			        	enabled: false
			        },
			        series: [{
			        	name: "水位",
			        	data: dataset,
			        	tooltip: { valueDecimals: 2}
			        }],
			        yAxis: [{
			        	max: max_set,
			            title: {
			                text: "水位(m)"
			            },
			            plotLines: stage_CL_setting
			        }]
				});
			})
			$("#region_cctv_trig").on(trigger_method, function(){
				pointCctvModalMap('<h5 class="font-weight-bold">' + this_marker.ObservatoryName + '水位站的CCTV地圖</h5>', "", this_layer, "limit")
			});
		}, 1000);
    }
    result = [stage_layer, data];
	return result;
}